import { combineReducers } from 'redux'
import UserReducer from './user/user.reducer'
import WordReducer from './word/word.reducer'
import FeedbackReducer from './feedback/feedback.reducer'
import ReportReducer from './report/report.reducer'
import OrderReducer from './order/order.reducer'
import DictReducer from './dict/dict.reducer'
import DefinitionReducer from './definition/definition.reducer'
import StatisticReducer from './statistic/statistic.reducer'
import NotificationReducer from './notification/notification.reducer'

const rootReducer = combineReducers({
	user: UserReducer,
	word: WordReducer,
	feedback: FeedbackReducer,
	report: ReportReducer,
	order: OrderReducer,
	dict: DictReducer,
	definition: DefinitionReducer,
	statistic: StatisticReducer,
	notification: NotificationReducer,
})

export default rootReducer
